import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';
import messages from 'src/pages/ProjectDetailsPage/messages';

const acceptShift = async ({
  jobUuid,
  applicationUuid,
  reason,
}: {
  jobUuid: string;
  applicationUuid: string;
  reason: string;
}) => {
  const payload = { job_application: { reason_code: reason } };

  const res = await putRequest(
    API.PUT.acceptShift(jobUuid, applicationUuid),
    payload,
  );
  return res.data;
};

export const useUpdateAcceptShift = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: acceptShift,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CALENDAR_JOBS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS_COUNT],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS],
      });
      handleSuccess(formatMessage(messages.applicationAccepted), 1000);
    },
    onError: handleError,
  });
};
